// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3yGQg","title":"Header_title__3qHyJ","side":"Header_side__1OonR"};